import { ChangeDetectionStrategy, Component } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AsyncPipe } from '@angular/common';
import { MapWithSidebarModule } from '@ui/shared/feature-map';
import { BaseAppComponent } from '@ui/shared/feature-config';
import {
    FoundingMapItemPopupContentComponent,
} from './components/founding-map-item-popup-content/founding-map-item-popup-content.component';
import { FoundingMapItemDetailsComponent } from './components/founding-map-item-details/founding-map-item-details.component';
import { FoundingMapItemModel } from './entities/founding-map-item.model';
import { FilterMapperComponent } from '@ui/shared/ui-filter';

@Component({
    imports: [
        RouterModule,
        AsyncPipe,
        MapWithSidebarModule,
        FoundingMapItemDetailsComponent,
        FilterMapperComponent,
    ],
    selector: 'ui-founding-map-root',
    templateUrl: './app.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent extends BaseAppComponent<FoundingMapItemModel> {
    constructor() {
        super(FoundingMapItemPopupContentComponent);
    }
}
